import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/config";
import { COPY_COLLECTION } from "./merchCopyCampaign";
export async function merchCopyRequestsLoader() {
  const result = await getDocs(collection(db, COPY_COLLECTION));
  return result.docs.map(doc => ({ ...doc.data(), id: doc.id }))
    .sort((a, b) => (b.date?.toMillis?.() ?? 0) - (a.date?.toMillis?.() ?? 0));
}
